import React, { PureComponent } from 'react'
import { css } from 'emotion'

class MyComponent extends PureComponent {
  render () {
    const { left, top, widthPlus, isInvalidDraggedIndex } = this.props
    return (
      <div className={css`
    position: absolute;
    left: ${left}px;
    top: ${top}px;
    width: ${widthPlus ? 125 + widthPlus : 125}px;
    height: 5px;
    box-sizing: border-box;
    border: ${isInvalidDraggedIndex ? 'thin solid rgba(142, 204, 9, 0.3)' : 'none'};
    background-color: ${isInvalidDraggedIndex ? 'transparent' : 'rgba(142, 204, 9, 0.3)'};
    z-index: 100;
    `} />
    )
  }
}

export default MyComponent
